let topShopProfileTriggeredHash = {};

// Debounce utility function
function debounce(fn, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const infiniteLoader = document.querySelector('[data-infinite-loader]');

  if (!infiniteLoader) return;

  const listEle = document.getElementById(infiniteLoader.getAttribute('data-infinite-loader'));
  if (!listEle) return;

  const infiniteHandler = () => {
    const isMobile = window.matchMedia("only screen and (max-width: 639px)").matches;
    const deviceHeight = document.documentElement.clientHeight;

    const shouldTrigger = isMobile
      ? listEle.getBoundingClientRect().bottom <= (deviceHeight + 200)
      : (listEle.scrollTop + listEle.clientHeight) >= (listEle.scrollHeight * 0.85);

    if (!shouldTrigger) return;

    const nextLink = document.querySelector('[data-infinite-loader] a');
    if (nextLink && !topShopProfileTriggeredHash[nextLink.href]) {
      topShopProfileTriggeredHash[nextLink.href] = true;
      nextLink.click();
    }
  };

  const debouncedHandler = debounce(infiniteHandler, 200);

  listEle.addEventListener('scroll', debouncedHandler);
  listEle.addEventListener('touchmove', debouncedHandler);
  window.addEventListener('resize', debouncedHandler);

  if (infiniteLoader.hasAttribute('data-infinite-loader-onload')) {
    const nextLink = document.querySelector('[data-infinite-loader] a');
    if (nextLink && !topShopProfileTriggeredHash[nextLink.href]) {
      topShopProfileTriggeredHash[nextLink.href] = true;
      nextLink.click();
    }
  }
});
